import { Dialog, IconButton } from '@fluentui/react';
import React, { useState, useEffect } from 'react'
import Api from '../../../services/Api'
import { ItemPicker } from '../../CreateSite/CommonComponents/ItemPicker'
import TreeComponent from '../../CreateSite/CommonComponents/TreeComponent';


const DimensionPicker = ({itemSelector, searchTitle, searchDataUrl, treeDataUrl, rootTreeDataUrlParams, isDisabled, selection, isRequired, additionalOptions, dimensionConfig, isreadonly}) => {

    const [treeData, setTreeData] = useState([]);
    const [isDialogHidden, setIsDialogHidden] = useState(true);

    useEffect(() => {
        let isMounted = true;
        Api.get(`${treeDataUrl}?${dimensionConfig.onlyChildrenAllowed ? `key=${dimensionConfig.defaultKey}&parent=all` : 'parent=abb'}`)
            .then(res => res.data)
            .then(items => {
                if (additionalOptions) {
                    items = [...additionalOptions, ...items];
                }
                if(isMounted) {
                    setTreeData(items);
                }
            });
        return () => isMounted = false;
    }, []);

    useEffect(() => {
        setIsDialogHidden(true);
    }, [selection])
    
    const modalTree = <div>
        {   
            treeData.map(item => 
                <TreeComponent
                    key = {item.key}
                    child = {item}
                    itemSelector = {itemSelector}
                    selectedItem = {selection}
                    url = {treeDataUrl}
                />)
        }
        </div>

    return (
        <div style={{display: 'flex', alignItems: 'flex-end'}}>
            <ItemPicker
                itemSelector={itemSelector}
                searchTitle={searchTitle}
                url={`${searchDataUrl}?${dimensionConfig.onlyChildrenAllowed ? `parent=${dimensionConfig.defaultKey}&` : ''}search=`}
                isPickerDisabled={isDisabled || dimensionConfig.isDisabled || isreadonly}
                selection={selection}
                isRequired={isRequired}
                additionalOptions={additionalOptions}
                styles={{fontSize:'14px', fontWeight:'normal'}}
            />
            <IconButton  
                disabled={isDisabled || dimensionConfig.isDisabled || isreadonly}
                iconProps={{
                    iconName: 'bulletedTreeList'
                }}
                onClick={() => setIsDialogHidden(false)}
            />
            <Dialog
                hidden={isDialogHidden}
                onDismiss={() => setIsDialogHidden(true)}
                modalProps={{
                    isBlocking: false,
                    dragOptions: true
                }}
                minWidth={400}
                maxWidth={600}
            >
                {modalTree}
            </Dialog>
        </div>
    );
}

export default DimensionPicker


// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/DimensionPicker.js